<template>
  <div id="accountDetail">
    <el-card v-loading="detailLoading">
      <!-- Return Button -->
      <div class="return-btn" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        Return
      </div>

      <!-- Account Info Header -->
      <div class="acct-info-block">
        <div class="acct-info-row">
          <div class="acct-info-item">
            <span class="acct-info-label">Rep. Office:</span>
            <span class="acct-info-value">{{ accountInfo.country }}</span>
          </div>
          <div class="acct-info-item">
            <span class="acct-info-label">Account Service No. (GTS):</span>
            <span class="acct-info-value">{{ accountInfo.gtsCode }}</span>
          </div>
          <div class="acct-info-item">
            <span class="acct-info-label">Account Name:</span>
            <span class="acct-info-value">{{ accountInfo.accountName }}</span>
          </div>
        </div>
      </div>

      <!-- Main Tabs -->
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="Labour Hour" name="labourHour">
          <labour-hour :accountInfo="accountInfo" ref="labourHour"></labour-hour>
        </el-tab-pane>
        <!-- <el-tab-pane label="Web to Case" name="webToCase">
          <web-to-case :accountInfo="accountInfo"></web-to-case>
        </el-tab-pane> -->
        <el-tab-pane label="Pre-Sales Test" name="preSalesTest">
          <pre-sales-test :accountInfo="accountInfo"></pre-sales-test>
        </el-tab-pane>
        <el-tab-pane label="Major Project" name="majorProject">
          <major-project :accountInfo="accountInfo"></major-project>
        </el-tab-pane>
        <el-tab-pane label="Install Base" name="onlineEquipment">
          <online-equipment :accountInfo="accountInfo"></online-equipment>
        </el-tab-pane>
        <el-tab-pane label="Spare Parts Replacement" name="spareParts">
          <spare-parts :accountInfo="accountInfo"></spare-parts>
        </el-tab-pane>
        <el-tab-pane label="Account Profile" name="accountProfile">
          <account-profile :accountInfo="accountInfo"></account-profile>
        </el-tab-pane>

        <el-tab-pane label="Documents" name="documents">
          <documents :accountInfo="accountInfo"></documents>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import LabourHour from './accountDetailTabs/LabourHour.vue'
// import WebToCase from './accountDetailTabs/WebToCase.vue'
import PreSalesTest from './accountDetailTabs/PreSalesTest.vue'
import MajorProject from './accountDetailTabs/MajorProject.vue'
import OnlineEquipment from './accountDetailTabs/OnlineEquipment.vue'
import SpareParts from './accountDetailTabs/SpareParts.vue'
import AccountProfile from './accountDetailTabs/AccountProfile.vue'
import Documents from './accountDetailTabs/Documents.vue'

export default {
  name: 'accountDetail',
  components: {
    LabourHour,
    // WebToCase,
    PreSalesTest,
    MajorProject,
    OnlineEquipment,
    SpareParts,
    AccountProfile,
    Documents,
  },
  computed: {
    accountId() {
      return this.$route.params.id
    }
  },
  data() {
    return {
      activeTab: this.$route.query.activeTab || 'labourHour',
      accountInfo: {},
      detailLoading: false,
    }
  },
  created() {
    this.fetchDetail()
  },
  activated() {
    // 从 majorProject 返回时，通过 query.activeTab 恢复之前选中的 tab
    const activeTab = this.$route.query.activeTab
    if (activeTab) {
      this.activeTab = activeTab
    }
  },
  methods: {
    fetchDetail() {
      if (!this.accountId) return
      this.detailLoading = true
      let url = `${this.$store.state.islhurl}valued-account/${this.accountId}`
      this._get(url).then(res => {
        this.detailLoading = false
        if (res.code === 200 && res.data) {
          this.accountInfo = res.data
        }
      }).catch(() => {
        this.detailLoading = false
      })
    },
    goBack() {
      const fromRoute = this.$route.query.from || 'informationManagement'
      this.$router.push({ name: fromRoute })
    },
    handleTabClick(tab) {
      // Fix: el-table fixed列在tab切换(display:none→visible)后布局计算错误
      // 需要在$nextTick中强制重新布局，否则fixed-right列高度会偏小导致最后一行按钮被截断
      this.$nextTick(() => {
        const tables = this.$el.querySelectorAll('.el-table')
        tables.forEach(table => {
          const tableComponent = table.__vue__
          if (tableComponent && typeof tableComponent.doLayout === 'function') {
            tableComponent.doLayout()
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
#accountDetail {
  .return-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #007AFF;
    font-size: 13px;
    cursor: pointer;
    margin-bottom: 16px;
    &:hover {
      color: #0066D4;
    }
  }

  .acct-info-block {
    padding: 0 0 10px 24px;
  }
  .acct-info-row {
    display: flex;
    gap: 55px;
    align-items: baseline;
  }
  .acct-info-item {
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
  .acct-info-label {
    font-size: 13px;
    color: #6B7280;
    font-weight: 700;
    white-space: nowrap;
  }
  .acct-info-value {
    font-size: 13px;
    color: #1F2937;
    font-weight: 400;
  }

  /deep/.el-tabs__content {
    padding: 10px 15px;
  }
  /deep/.el-tabs__item {
    color: #6b7280;
    font-weight: normal;
  }
  /deep/.el-tabs__item.is-active {
    color: #409EFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/accountDetail.vue